import { IconCar16, IconWalk16 } from '@cian/ui-kit/icons';
import { ETransportType } from '../../types/recommendations';
export var TRANSPORT_ICON_MAP = new Map([[ETransportType.Transport, IconCar16], [ETransportType.Walk, IconWalk16]]);